import colors from "../../base/colors";
import typography from "../../base/typography";
import pxToRem from "../../functions/pxToRem";

const { text } = colors;
const { fontWeightBold } = typography;

const formLabel = {
  styleOverrides: {
    root: {
      color: text.main,
      fontSize: pxToRem(14),
      fontWeight: fontWeightBold,
      lineHeight: 1.4,
      marginBottom: pxToRem(4),
    },
  },
};

export default formLabel;
